export var APPEND_INIIALIZE = "@@firekit/COLLECTIONS@APPEND_INIIALIZE";
export var INIIALIZE = "@@firekit/COLLECTIONS@INIIALIZE";
export var DESTROY = "@@firekit/COLLECTIONS@DESTROY";
export var UNWATCH = "@@firekit/COLLECTIONS@UNWATCH";
export var CHILD_ADDED = "@@firekit/COLLECTIONS@CHILD_ADDED";
export var CHILD_CHANGED = "@@firekit/COLLECTIONS@CHILD_CHANGED";
export var CHILD_REMOVED = "@@firekit/COLLECTIONS@CHILD_REMOVED";


//////////////////
// WEBPACK FOOTER
// ./node_modules/firekit/es/store/collections/types.js
// module id = 169
// module chunks = 49